import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer      from './slices/authSlice';
import uiReducer        from './slices/uiSlice';
import workspaceReducer from './slices/workspaceSlice';

export const store = configureStore({
  reducer: {
    auth:      authReducer,
    ui:        uiReducer,
    workspace: workspaceReducer,
  },
  devTools: import.meta.env.DEV,
});

export type RootState   = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch        = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
